import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  frameId: string;

  constructor(
    private route: ActivatedRoute,
    private titleService: Title,
    private router: Router,
  ) {
    router.events.subscribe(event => {
      var title = this.getTitle(router.routerState, router.routerState.root).join('-');
      titleService.setTitle(title);
    });
  }

  // collect that title data properties from all child routes
  // there might be a better way but this worked for me
  getTitle(state, parent) {
    var data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(... this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.frameId = params.frameId;
      if (params.frameId) {
        setInterval(function () {
          window.parent.postMessage(
            // get height of the content
            {
              height: document.body.scrollHeight,
              id: params.frameId
            }
            // set target domain
            , "*"
          )
        }, 150);
      }

    });

  }

}
